import ActivityPage from './ActivityPage';

const SteamQuest = () => <ActivityPage activityKey="steamQuest" />;

export default SteamQuest;
